import React from 'react'
import { Modal, ModalBody, Button } from 'reactstrap'
import PropTypes from 'prop-types'
import { MdClear } from 'react-icons/md'
import { Header } from './VideoModalStyledComponents'

const VideoModal = React.memo(({ name, open, video = '', toggle }) => {
  const extension = video
    .replace('ogv', 'ogg')
    .split('.')
    .splice(-1, 1)
  return (
    <Modal size='lg' centered isOpen={open} toggle={toggle}>
      <Header>
        <span>{name}</span>
        <Button color='lightGray' className='btn-circle-sm' onClick={toggle}>
          <MdClear />
        </Button>
      </Header>
      <ModalBody>
        <video width='100%' autoPlay controls>
          <source src={video} type={`video/${extension}`} />
        </video>
      </ModalBody>
    </Modal>
  )
})

VideoModal.displayName = 'VideoModal'

VideoModal.propTypes = {
  name: PropTypes.string,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  video: PropTypes.string.isRequired
}

export default VideoModal
